// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"d63ce9ec","956":"106a36e1"}[chunkId] + ".chunk.js";
};